import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { Uploads } from '../../../services/uploads';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import firebase from 'firebase';
import { FinishProcessPage } from '../../../finish-process/finish-process';
import { DeliberyNoteServices } from '../../services';
import { IngredientsServices } from '../../../ingredients/services';
import { ProductsServices } from '../../../products/services';
import { StockListPage } from '../../../stock/stock-list/stock-list';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the DeliberyNoteResultFotoIa page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-result-foto-ia',
  templateUrl: 'delibery-note-result-foto-ia.html',
})
export class DeliberyNoteResultFotoIa implements OnInit, OnDestroy {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  private debounceTimer: any = null;
  public image_url_delibery_view: Observable<string | null>;
  img_ref: string = null;
  selectedFiles: FileList;
  TextCloudVision: string = "";
  listProduct = []
  listProvider = [];
  cadenaBusqueda: string = '';
  filteredProducts: any[] = []
  provider_static: string = null;
  date = null;
  number: number = null;
  delibery_note_uid = null;
  json_Response = <any>Promise;
  TotalNoTax: number = 0;
  filteredResults: { [index: string]: any[] } = {};
  show_alert: boolean = true;
  elements_stock = [];
  update_state: boolean = false
  ArrayAnalitica
  activeSearchIndex: number | null = null;
  totalTax: number;
  subtotal: number;
  total: number;
  events: any;
  showCreateProviderMessage: boolean = false;

  // Arrays auxiliares para cálculo por cajas (no se guardan en BD)
  public boxes: number[] = [];
  public unitsPerBox: number[] = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    private alertCtrl: AlertController,
    public uploadServices: Uploads,
    public http: HttpClient,
    public translate: TranslateService,
    public deliberyNoteServices: DeliberyNoteServices,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    public analyticsService: AnalyticsServices,
    private cdRef: ChangeDetectorRef) {

    // obtener los resultados del processo de ia para poder desplegarlo
    const rawResponse = this.navParams.get('json_Response');

    // Create a clean copy without converting date
    this.json_Response = { ...rawResponse };

    // Obtener la referencia de la imagen si existe
    this.img_ref = this.navParams.get('img_ref');

    this.update_state = this.navParams.get('update_state');

    if (this.navParams.get('show_alert')) {
      this.show_alert = this.navParams.get('show_alert');
    }
    else if (this.navParams.get('isIA')) {
      this.show_alert = true;
    }
    else {
      this.show_alert = false;
    }

    if (typeof (this.update_state) != "boolean") {
      this.update_state = false;
    }
    if (this.update_state == true) {
      if (this.json_Response.UID) {
        // eliminamos el UID y la ponemos como un variable para poder hacer el update
        this.delibery_note_uid = this.json_Response.UID;
      } else {
        this.delibery_note_uid = this.navParams.get('delibery_note_uid');
      }
    }
  }

  async ionViewWillEnter() {
    const loader = this.loadingCtrl.create({
      content: this.translate.instant('general-cargando-datos'),
      duration: 5000
    });
    loader.present();

    try {
      // Obtener la URL de la imagen si existe
      if (this.img_ref) {
        this.getImageUrl(this.img_ref);
      }

      // Instead of double parsing, let's do a simple clone
      this.ArrayAnalitica = { ...this.json_Response };

      this.IngredientToProduct();
      this.listProvider = await this.ImportProvider();
      this.listProduct = await this.ImportProduct();
      await this.DeployProducts(this.json_Response);

      // Inicializar arrays auxiliares para cálculo por cajas
      this.initBoxCalculation();

      // Verificar si el provider_static existe en la lista de proveedores (sin importar mayúsculas/minúsculas)
      const selectedProvider = this.listProvider.find(provider => provider.provider_static.toLowerCase() === this.json_Response.provider_static.toLowerCase());
      if (selectedProvider) {
        this.json_Response.provider_static = selectedProvider.provider_static; // Establecer el nombre del proveedor para mostrar
        this.json_Response.uid_provider = selectedProvider.uid_provider; // Establecer el uid del proveedor
      } else {
        this.json_Response.uid_provider = "";
        this.showCreateProviderMessage = true; // Bandera para mostrar mensaje de creación de proveedor
      }
    } catch (error) {
    } finally {
      loader.dismiss();
      this.cdRef.detectChanges();
      this.calculateTotals();
    }
  }

  ngOnDestroy() {
    // Limpiar timeout al destruir la vista para evitar ViewDestroyedError
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  // para cambiar variable uid_ingredient a product en la lista temporalmente , luego se vuelve a su estado 
  IngredientToProduct() {
    for (let i = 0; i < this.json_Response.list.length; i++) {
      if (this.json_Response.list[i].type === 'ingredient' && this.json_Response.list[i].uid_ingredient) {
        this.json_Response.list[i].uid_product = this.json_Response.list[i].uid_ingredient;
      }
    }
  }

  // PARA IMPORTAR LOS PRODCUTOS DEL RESTAURANTE 
  async ImportProduct() {
    const productsRef = firebase.firestore().collection('products');
    const ingredientsRef = firebase.firestore().collection('ingredients');

    try {
      // Run both Firestore queries in parallel
      const [productsSnapshot, ingredientsSnapshot] = await Promise.all([
        productsRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get(),
        ingredientsRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get()
      ]);

      let list_array_tmp = [];

      // Process Products
      productsSnapshot.forEach(doc => {
        const _doc = doc.data();
        let tax_provider = 0;
        let price_provider = 0;
        if (this.json_Response.uid_provider && _doc.providers != undefined) {
          let index_provider = _doc.providers.findIndex(x => x.uid === this.json_Response.uid_provider);
          if (index_provider !== -1) {
            tax_provider = _doc.providers[index_provider].tax_static || 0;
            price_provider = _doc.providers[index_provider].price_static || 0;
          }
        }

        list_array_tmp.push({
          uid_product: doc.id,
          type: 'product',
          name: _doc.name,
          measurement: _doc.measurement,
          ean: _doc.ean,
          tax: tax_provider,
          price_static: price_provider
        });
      });

      // Process Ingredients
      ingredientsSnapshot.forEach(doc => {
        const _doc = doc.data();
        let tax_provider = 0;
        let price_provider = 0;
        if (this.json_Response.uid_provider && _doc.providers != undefined) {
          let index_provider = _doc.providers.findIndex(x => x.uid === this.json_Response.uid_provider);
          if (index_provider !== -1) {
            tax_provider = _doc.providers[index_provider].tax_static || 0;
            price_provider = _doc.providers[index_provider].price_static || 0;
          }
        }

        list_array_tmp.push({
          uid_ingredient: doc.id,
          type: 'ingredient',
          name: _doc.name,
          measurement: _doc.measurement,
          ean: "",
          tax: tax_provider,
          price_static: price_provider
        });
      });

      return list_array_tmp;

    } catch (error) {
      return [];
    }
  }


  // si el usuario no quiere seguir el processo , vuelve al inicio y rompe todo el processo 
  ionViewCanLeave(): Promise<void> {
    if (this.show_alert === true) {
      return new Promise((resolve, reject) => {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      });
    }
  }

  // PARA IMPORTAR LOS PROVEEDORES  DEL RESTAURANTE 
  async ImportProvider() {
    let list_array_tmp = Array();
    const providerRef = firebase.firestore().collection('providers');
    await providerRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        let product = {
          "uid_provider": doc.id,
          "provider_static": _doc.name,
        };
        list_array_tmp.push(product);
      });
    });
    return list_array_tmp
  }

  getImageUrl(image_ref) {
    //Get image url for show . Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.uploadServices.storage.ref(image_ref);
    this.image_url_delibery_view = ref.getDownloadURL();
  }

  // funcion para añadir 0 si es menos de 10 el el dia y el mes
  padStart(str: string, targetLength: number, padString: string): string {
    if (str.length >= targetLength) {
      return str;
    } else {
      targetLength = targetLength - str.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + str;
    }
  }

  isDateObject(object: any): boolean {
    return object instanceof Date;
  }

  isFirestoreTimestamp(object) {
    return object instanceof firebase.firestore.Timestamp ||
      ("toDate" in object && typeof object.toDate === "function");
  }

  parseFormattedDate(dateString: string): Date {
    const monthMap: { [key: string]: number } = {
      "enero": 0, "febrero": 1, "marzo": 2, "abril": 3, "mayo": 4, "junio": 5,
      "julio": 6, "agosto": 7, "septiembre": 8, "octubre": 9, "noviembre": 10, "diciembre": 11
    };

    // Match date components
    const regex = /(\d+) de (\w+) de (\d+), (\d+):(\d+):(\d+) ([ap]\.m\.) (UTC[+-]\d+|CET|CEST)/;
    const match = dateString.match(regex);

    if (!match) {
      return new Date();
    }

    const [, day, monthStr, year, hourStr, minute, second, ampm, timeZone] = match;

    // Convert values
    const yearNum = parseInt(year, 10);
    const monthNum = monthMap[monthStr.toLowerCase()];
    const dayNum = parseInt(day, 10);
    let hourNum = parseInt(hourStr, 10);
    const minuteNum = parseInt(minute, 10);
    const secondNum = parseInt(second, 10);

    // Handle 12-hour format
    if (ampm === "p.m." && hourNum !== 12) {
      hourNum += 12;
    } else if (ampm === "a.m." && hourNum === 12) {
      hourNum = 0;
    }

    // Handle time zones
    let offset = 0;
    if (timeZone.startsWith("UTC")) {
      offset = parseInt(timeZone.replace("UTC", ""), 10);
    } else if (timeZone === "CET") {
      offset = 1;
    } else if (timeZone === "CEST") {
      offset = 2;
    }

    // Create UTC Date object
    const dateUTC = new Date(Date.UTC(yearNum, monthNum, dayNum, hourNum, minuteNum, secondNum));
    dateUTC.setUTCHours(dateUTC.getUTCHours() - offset);

    return dateUTC;
  }

  // dar formato al date para inserterlo al input date
  TimestampToDate(json_Response: any): Date {

    if (!json_Response.date) {
      return new Date(); // Fallback to current date
    }

    let date: Date;

    if (this.isFirestoreTimestamp(json_Response.date)) {
      // Convert Firestore Timestamp to Date
      date = json_Response.date.toDate();
    } else if (typeof json_Response.date === "string") {
      // Convert formatted string to Date object
      date = this.parseFormattedDate(json_Response.date);
    } else if (json_Response.date instanceof Date) {
      date = json_Response.date;
    } else {
      date = new Date(json_Response.date);
    }

    if (isNaN(date.getTime())) {
      return new Date();
    }

    return date;
  }


  // desplegamos los datos del albaran
  deploy(json_Response): Promise<any> {
    return new Promise((resolve, reject) => {
      if (json_Response) {
        resolve(json_Response); // Resuelve la promesa con json_Response
      } else {
        reject('No hay respuesta JSON'); // Rechaza la promesa si json_Response no está presente
      }
    });
  }

  // desplegamos los prodcutos del alabran detectado por ia
  async DeployProducts(json_Response) {
    // ✅ Store Firestore Timestamp as is, but format for display
    this.date = this.convertToInputFormat(json_Response.date);

    await this.deploy(json_Response).then(res => {
      this.provider_static = res.provider_static;
      this.number = res.number;
      this.json_Response = json_Response;

      // Ensure old JSON formats don't break
      for (let i = 0; i < json_Response.list.length; i++) {
        if (json_Response.list[i].reference === undefined) {
          json_Response.list[i].reference = "";
        }
        if (json_Response.list[i].lots === undefined) {
          json_Response.list[i].lots = "";
        }
      }

      this.listProduct = json_Response.list;
      this.listProduct.forEach(p => {
        if (p.type_discount === undefined) {
          p.type_discount = 'discount_percentage';
        }
      });

      // ✅ INICIALIZAR ARRAYS INMEDIATAMENTE después de asignar listProduct
      this.initBoxCalculation();
    });
  }

  convertToInputFormat(dateInput: any): string {

    if (!dateInput) {
      return '';
    }

    try {
      // If dateInput is already a string in YYYY-MM-DD format
      if (typeof dateInput === "string") {
        // Check for YYYY-MM-DD format
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
          return dateInput;
        }

        // Check for DD/MM/YYYY format
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateInput)) {
          const [day, month, year] = dateInput.split('/').map(num => parseInt(num, 10));
          return `${year}-${this.padStart(String(month), 2, '0')}-${this.padStart(String(day), 2, '0')}`;
        }
      }

      // If it's a Firestore timestamp
      if (dateInput instanceof firebase.firestore.Timestamp) {
        const d = dateInput.toDate();
        const year = d.getFullYear();
        const month = this.padStart(String(d.getMonth() + 1), 2, '0');
        const day = this.padStart(String(d.getDate()), 2, '0');
        return `${year}-${month}-${day}`;
      }

      // If it's a Date object
      if (dateInput instanceof Date && !isNaN(dateInput.getTime())) {
        const year = dateInput.getFullYear();
        const month = this.padStart(String(dateInput.getMonth() + 1), 2, '0');
        const day = this.padStart(String(dateInput.getDate()), 2, '0');
        return `${year}-${month}-${day}`;
      }

      // If we get here, the format is not supported
      return '';

    } catch (error) {
      return '';
    }
  }

  // importamos los proveedor a la lista 
  async ngOnInit() {
    this.listProvider = await this.ImportProvider();
  }

  // si se cambia los datos del albaran 
  onSelectionChange(value: string, attribute: string) {
    if (attribute === 'uid_provider') {
      this.json_Response[attribute] = value;
      const provider = this.listProvider.find(elemento => elemento.uid_provider === value);
      if (provider) {
        this.json_Response.provider_static = provider.provider_static;
      } else {
      }
    }

    if (attribute === 'date') {
      let selectedDate = new Date(value);
      this.json_Response.date = firebase.firestore.Timestamp.fromDate(selectedDate);
    }

    if (attribute === 'number') {
      this.json_Response.number = value;
    }

    this.calculateTotals(); // Ensure totals are updated
  }

  ///////////////////////////////////////////////////////////
  //para detectar si se cambia productos desplegados
  /////////////////////////////////////////////////////////

  //añadir producto  
  newAddProduct() {
    this.listProduct.push({
      ean: "",
      measurement: "",
      name: "",
      price: 0,
      quantity: 0,
      discount: 0,
      type_discount: 'discount_percentage',
      tax: 0,
      total: 0,
      type: "",
      uid_product: "",
      lots: "",
      reference: ""
    });

    // Inicializar arrays auxiliares para el nuevo producto
    this.boxes.push(null);
    this.unitsPerBox.push(null);

    this.calculateTotals();
  }

  // eliminar producto de la tabla pregutando al usaurio
  async DeleteProduct(productToDelete: any) {
    const alert = this.alertCtrl.create({
      title: this.translate.instant('product-view-eliminar-producto'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            const index = this.listProduct.indexOf(productToDelete);
            this.listProduct = this.listProduct.filter(product => product !== productToDelete);
            this.json_Response.list = this.listProduct;

            // También eliminar de arrays auxiliares
            if (index !== -1) {
              this.boxes.splice(index, 1);
              this.unitsPerBox.splice(index, 1);
            }

            this.cdRef.detectChanges();
          }
        }
      ]
    });
    alert.present();

    this.calculateTotals();
  }

  // para filtrar los productos/ Ingredientes 
  async FilterProduct(product: any, index: number) {
    let lista_products = await this.ImportProduct();

    if (product.name) {
      product.uid_product = ""
      this.filteredResults[index] = lista_products.filter(element =>
        element.name.toLowerCase().includes(product.name.toLowerCase())
      );
      this.activeSearchIndex = index;
      this.cdRef.detectChanges();
    } else {
      this.filteredResults[index] = [];
      this.activeSearchIndex = null;
      this.cdRef.detectChanges();
    }
  }

  // ✅ Verificar si hay items que necesitan revisión manual
  hasItemsToReview(): boolean {
    if (!this.listProduct || this.listProduct.length === 0) return false;
    return this.listProduct.some(item => item._needsReview === true);
  }

  // ✅ Contar items que necesitan revisión
  getItemsToReviewCount(): number {
    if (!this.listProduct || this.listProduct.length === 0) return 0;
    return this.listProduct.filter(item => item._needsReview === true).length;
  }

  // ✅ Mostrar alternativas sugeridas para un item
  async showAlternatives(row: any, rowIndex: number) {
    if (!row._alternatives || row._alternatives.length === 0) return;

    // Crear mensaje con las alternativas
    let message = `<div style="text-align: left;">
      <p><strong>Producto detectado:</strong> ${row.name}</p>
      <p><strong>Confianza:</strong> ${row._matchConfidence ? row._matchConfidence.toFixed(0) : 0}%</p>
      <hr>
      <p><strong>Sugerencias del catálogo:</strong></p>
      <ul style="list-style: none; padding-left: 0;">`;

    row._alternatives.forEach((alt, i) => {
      message += `
        <li style="margin-bottom: 8px; padding: 8px; background: ${i === 0 ? '#e3f2fd' : '#f5f5f5'}; border-radius: 4px; cursor: pointer;" 
            id="alt-${i}">
          <strong>${i + 1}. ${alt.name}</strong><br>
          <small style="color: #666;">Confianza: ${alt.score.toFixed(0)}% | Tipo: ${alt.type === 'ingredient' ? 'Ingrediente' : 'Producto'}</small>
        </li>`;
    });

    message += `</ul>
      <p style="color: #666; font-size: 12px; margin-top: 12px;">
        💡 Selecciona una opción haciendo clic, o cierra para mantener el nombre detectado.
      </p>
    </div>`;

    const alert = await this.alertCtrl.create({
      title: 'Alternativas sugeridas',
      message: message,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        ...row._alternatives.map((alt, i) => ({
          text: `Usar "${alt.name}"`,
          handler: () => {
            // Asignar la alternativa seleccionada
            row.name = alt.name;
            row.uid_product = alt.uid;
            row.type = alt.type;
            row._needsReview = false;  // Marcar como revisado
            row._matchConfidence = alt.score;
            
            // Actualizar en listProduct
            this.listProduct[rowIndex] = row;
            this.cdRef.detectChanges();
          }
        }))
      ]
    });

    await alert.present();
  }

  // miramos si es producto se cambia directamente ud. para asegurar siempre sea ud.
  SelectMeasurementAndType(product) {
    if (product.type === 'product') {
      product.measurement = 'ud.'
    }
  }

  //seleccionar el elemento producto / ingrediente y lo asssina a la estractura de json_response
  SelectElement(product: any, selectedElement: any, index: number) {
    product.name = selectedElement.name;
    product.type = selectedElement.type;
    product.uid_product = selectedElement.uid_product;
    product.price = selectedElement.price_static;
    product.measurement = selectedElement.measurement;

    // si se cambia el producto y llega nuevo ingrediente le ponemos un uid_product temporal 
    if (selectedElement.uid_ingredient) {
      product.uid_product = selectedElement.uid_ingredient;
    }

    product.tax = selectedElement.tax;
    product.discount = 0;
    this.filteredProducts = []; // Limpia los resultados filtrados
    const productKey = index; // Asume que cada producto tiene un 'uid_product' único
    this.filteredResults[productKey] = [];
    this.activeSearchIndex = null;
    this.calculateTotals();
  }

  //calcular el total si se cambia de precio o cantidades o disscount etc
  //funcion para redondear el precio
  round(num: number, decimales: number, round_up = true): number {
    const factorDeEscala = Math.pow(10, decimales);
    if (round_up === true) {
      return Math.round(num * factorDeEscala) / factorDeEscala;
    }
    else {
      return Math.floor(num * factorDeEscala) / factorDeEscala;
    }
  }

  calcularTotal(product) {
    if (!product) return;

    product.quantity = product.quantity || 0;
    product.price = product.price || 0;
    product.discount = product.discount || 0;
    product.tax = product.tax || 0;

    let subtotal = product.quantity * product.price;
    let discount = subtotal * (product.discount / 100);

    if (product.type_discount === undefined || product.type_discount === 'discount_percentage') {
      discount = subtotal * (product.discount / 100);
    } else {
      discount = product.discount;
    }

    let SubTotalWithDiscount = subtotal - discount;
    let tax = SubTotalWithDiscount * (product.tax / 100);

    this.TotalNoTax = SubTotalWithDiscount, 2;
    product.total = this.round(SubTotalWithDiscount + tax, 2);

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      // Verificar que la vista aún existe antes de calcular
      if (this.cdRef && !this.cdRef['destroyed']) {
        this.calculateTotals();
      }
    }, 300);

    return product.total;
  }

  calculateTotals() {
    if (!this.listProduct || this.listProduct.length === 0) {
      this.subtotal = 0;
      this.totalTax = 0;
      this.total = 0;
      this.cdRef.detectChanges();
      return;
    }

    let newSubtotal = 0;
    let newTotal = 0;

    this.listProduct.forEach(product => {
      // Usar los totales individuales ya calculados y redondeados
      if (product.total) {
        newTotal += product.total;
      }
      
      // Calcular el subtotal sin impuestos (equivalente a "Sin IVA")
      const quantity = product.quantity || 0;
      const price = product.price || 0;
      const discount = product.discount || 0;

      let productSubtotal = quantity * price;
      let discountAmount = (product.type_discount === 'discount_percentage')
        ? (productSubtotal * discount) / 100
        : discount;

      let discountedSubtotal = productSubtotal - discountAmount;
      newSubtotal += discountedSubtotal;
    });

    // Redondear los totales a 2 decimales para evitar errores de precisión
    this.subtotal = this.round(newSubtotal, 2);
    this.total = this.round(newTotal, 2);
    
    // Calcular el impuesto como diferencia entre total y subtotal (igual que en la vista)
    this.totalTax = this.round(this.total - this.subtotal, 2);

    // Proteger detectChanges() contra ViewDestroyedError
    try {
      if (this.cdRef && !this.cdRef['destroyed']) {
        this.cdRef.detectChanges();
      }
    } catch (error) {
      // Ignorar errores si la vista ya fue destruida
    }
  }

  /**
   * Inicializar arrays auxiliares para cálculo por cajas
   */
  initBoxCalculation() {
    this.boxes = [];
    this.unitsPerBox = [];
    
    // Inicializar con valores vacíos para cada elemento
    for (let i = 0; i < this.listProduct.length; i++) {
      this.boxes[i] = null;
      this.unitsPerBox[i] = null;
    }
  }

  /**
   * Obtener el índice real de un producto de forma segura
   */
  getProductIndex(product: any): number {
    if (!this.listProduct || !product) {
      return -1;
    }
    const index = this.listProduct.indexOf(product);
    // Si no se encuentra, asegurar que los arrays estén inicializados
    if (index === -1 && this.listProduct.length > 0) {
      this.initBoxCalculation();
      return 0; // Fallback seguro
    }
    return index;
  }

  /**
   * Obtener valor de cajas de forma segura
   */
  getBoxesValue(index: number): number | null {
    if (!this.boxes || index < 0 || index >= this.boxes.length) {
      return null;
    }
    return this.boxes[index];
  }

  /**
   * Obtener valor de unidades por caja de forma segura
   */
  getUnitsPerBoxValue(index: number): number | null {
    if (!this.unitsPerBox || index < 0 || index >= this.unitsPerBox.length) {
      return null;
    }
    return this.unitsPerBox[index];
  }

  /**
   * Establecer valor de cajas de forma segura
   */
  setBoxesValue(index: number, value: number | null) {
    if (!this.boxes) {
      this.boxes = [];
    }
    // Asegurar que el array tenga suficiente tamaño
    while (this.boxes.length <= index) {
      this.boxes.push(null);
    }
    this.boxes[index] = value;
  }

  /**
   * Establecer valor de unidades por caja de forma segura
   */
  setUnitsPerBoxValue(index: number, value: number | null) {
    if (!this.unitsPerBox) {
      this.unitsPerBox = [];
    }
    // Asegurar que el array tenga suficiente tamaño
    while (this.unitsPerBox.length <= index) {
      this.unitsPerBox.push(null);
    }
    this.unitsPerBox[index] = value;
  }

  /**
   * Calcular cantidad total a partir de cajas y unidades por caja
   */
  calculateFromBoxes(index: number) {
    // Validar índice
    if (index < 0 || index >= this.listProduct.length) {
      return;
    }

    const boxes = this.boxes && index < this.boxes.length ? this.boxes[index] : null;
    const unitsPerBox = this.unitsPerBox && index < this.unitsPerBox.length ? this.unitsPerBox[index] : null;
    
    // Solo calcular si ambos valores están presentes y son mayores a 0
    if (boxes && unitsPerBox && boxes > 0 && unitsPerBox > 0) {
      // Calcular cantidad total
      const totalUnits = boxes * unitsPerBox;
      
      // Actualizar el campo de cantidad del producto
      this.listProduct[index].quantity = totalUnits;
      
      // Recalcular el total del producto/ingrediente
      this.calcularTotal(this.listProduct[index]);
    }
  }

  async sendAnaliticaWhenUpdate() {
    this.elements_stock = [];

    for (let i = 0; i < this.json_Response.list.length; i++) {
      const item = this.json_Response.list[i];
      
      // Obtener el UID correcto dependiendo del tipo
      const uid_element = item.type === 'ingredient' 
        ? item.uid_ingredient 
        : item.uid_product;
      
      //Hacemos push del elementos ha enviar a analytics
      this.elements_stock.push({
        "uid_element": uid_element,
        "name": item.name,
        "price": item.price * item.quantity, //price * quantity
        "quantity": item.quantity,
        "measurement": item.measurement,
        "modifier": `${this.translate.instant('general-editar-albaran')}`,
      });
    }

    await this.sendAnalitica();
  }

  async update() {
    this.show_alert = false;

    if (!this.json_Response || !this.update_state) {
      return;
    }

    // Mostrar loader durante el proceso de actualización
    const loader = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('general-guardando') + '...'
    });
    
    await loader.present();

    try {
      this.json_Response.list.forEach(item => {
        if (item.type === 'ingredient') {
          delete item.uid_product;
        }
      });

      // Ensure correct date conversion
      this.json_Response.date = this.TimestampToDate(this.json_Response);

      let cleanedData = JSON.parse(JSON.stringify(this.json_Response, (key, value) => {
        if (value === undefined) return '';
        if (typeof value === "string" && value.trim() === "") return '';
        if (Array.isArray(value) && value.length === 0) return '';
        return value;
      }));

      cleanedData.date = new Date(this.json_Response.date); // Ensure Date format
      
      // Asegurar que tenga estado 'completed' (para albaranes antiguos sin state)
      if (!cleanedData.state) {
        cleanedData.state = 'completed';
      }

      if (!this.delibery_note_uid) {
        throw new Error("Missing delibery_note_uid. Cannot update Firestore.");
      }

      await this.productsServices.afs.collection('delibery_note')
        .doc(this.delibery_note_uid)
        .update(cleanedData);

      await this.deliberyNoteServices.getLatestDeliveryNote(cleanedData);
      this.deliberyNoteServices.notifyDeliveryNoteUpdated();

      await this.getValuesToUpdate(cleanedData);
      await this.sendAnaliticaWhenUpdate();
      this.calculateTotals();

    } catch (error) {
      console.error('Error al actualizar albarán:', error);
    } finally {
      // Cerrar el loader antes de navegar
      try {
        await loader.dismiss();
      } catch (dismissError) {
        // El loader ya estaba cerrado
      }
      
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.navCtrl.setRoot(FinishProcessPage, {
          uid_element: this.delibery_note_uid,
          type: 'delibery_note',
          update_state: this.update_state // Usar el campo existente
        });
      }, 300);
    }
  }

  // crear nuevo proveedor
  async newprovider(json_response) {
    const productsRef = firebase.firestore()
    await productsRef.collection('providers').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': json_response.provider_static,
      'contact_name': json_response.provider_static,
      'address': json_response.address || "",
      'email': json_response.email || null,
      'fixed_phone': "",
      'nif': json_response.nif || "",
      'no_provider': false,
      'phone': json_response.phone || null,
      'updated_at': new Date(),
      'debug': true
    }).then(id => {
      json_response.uid_provider = id.id
    })
  }

  CreateArrayAnalitics(json_response, uid, _newPrice) {
    //Hacemos push del elementos ha enviar a analytics
    this.elements_stock.push({
      "uid_element": uid,
      "name": json_response.name,
      "price": _newPrice * json_response.quantity, //price * quantity
      "quantity": json_response.quantity,
      "measurement": json_response.measurement,
      "modifier": `${this.translate.instant('finish-process-crear-nuevo-albaran')}`,
    });
  }

  UpdateElement(element, json_response, _tax, _newPrice, _total) {
    //Buscamos el proveedor por defecto y lo desactivamos
    let index_provider_default = element.providers.findIndex(x => x.default == true);
    if (index_provider_default != -1) {
      element.providers[index_provider_default].default = false;
    }

    //Actualizamos la informacion de los proveedor del elemento
    let index_provider = element.providers.findIndex(x => x.uid === this.json_Response.uid_provider);
    if (index_provider != -1) {
      element.providers[index_provider].tax_static = _tax;
      element.providers[index_provider].price_static = _newPrice;
      element.providers[index_provider].pricetotal_static = _total;
      element.providers[index_provider].default = true;
      element.provider_static = json_response.provider_static;
      element.price_static = _newPrice;
    } else {
      // si no existe le creamos uno 
      element.providers.push({
        default: true,
        name_static: json_response.provider_static,
        price_static: _newPrice,
        pricetotal_static: _total,
        tax_static: _tax,
        uid: this.json_Response.uid_provider,
        updated_at: new Date()
      });
      element.provider_static = json_response.provider_static;
      element.price_static = _newPrice;
    }
    this.calculateTotals();
  }

  //Función donde modificaremos los nuevos valores de stock y precio
  async getValuesToUpdate(json_response) {
    if (!json_response.uid_provider) {
      await this.newprovider(json_response);
    }

    // UPDATE STATE
    if (this.update_state === true) {
      json_response = this.json_Response;

      // recorremos la lista antigua para restar el stock de cada producto
      try {
        // OPTIMIZACIÓN: Recopilar todos los UIDs primero
        const ingredientUids: string[] = [];
        const productUids: string[] = [];
        
        for (let i = 0; this.ArrayAnalitica.list.length > i; i++) {
          const uid = this.ArrayAnalitica.list[i].uid_product || this.ArrayAnalitica.list[i].uid_ingredient;
          if (uid && uid !== "") {
            if (this.ArrayAnalitica.list[i].type === 'ingredient') {
              ingredientUids.push(uid);
            } else if (this.ArrayAnalitica.list[i].type === 'product') {
              productUids.push(uid);
            }
          }
        }

        for (let i = 0; json_response.list.length > i; i++) {
          const uid = json_response.list[i].uid_product || json_response.list[i].uid_ingredient;
          if (uid && uid !== "") {
            if (json_response.list[i].type === 'ingredient' && !ingredientUids.includes(uid)) {
              ingredientUids.push(uid);
            } else if (json_response.list[i].type === 'product' && !productUids.includes(uid)) {
              productUids.push(uid);
            }
          }
        }

        // OPTIMIZACIÓN: Obtener todos los documentos en batch
        const ingredientsMap = await this.getBatchDocuments('ingredients', ingredientUids);
        const productsMap = await this.getBatchDocuments('products', productUids);

        // Crear batch para todas las actualizaciones
        const batch = this.ingredientsServices.afs.firestore.batch();
        
        // Procesar lista antigua para restar stock
        for (let i = 0; this.ArrayAnalitica.list.length > i; i++) {
          const uid = this.ArrayAnalitica.list[i].uid_product || this.ArrayAnalitica.list[i].uid_ingredient;
          const _OldStock = this.ArrayAnalitica.list[i].quantity;
          const _OldPrice = this.ArrayAnalitica.list[i].price;
          const _Oldtax = this.ArrayAnalitica.list[i].tax;

          if (this.ArrayAnalitica.list[i].type === 'ingredient' && uid && uid !== "") {
            const ingredient = ingredientsMap[uid];
            if (ingredient) {
              const stock_ingr = parseFloat(ingredient.stock) - _OldStock;
              const _total_ingr = (_OldPrice * _Oldtax / 100) - _OldPrice;

              this.UpdateElement(ingredient, this.ArrayAnalitica, _Oldtax, _OldPrice, _total_ingr);
              
              // Añadir al batch en lugar de update individual
              const docRef = this.ingredientsServices.afs.firestore.collection('ingredients').doc(uid);
              batch.update(docRef, {
                'stock': stock_ingr,
                'price_static': _OldPrice,
                'providers': ingredient.providers,
              });
              
              // No bloquear el proceso con await para tracking (menos crítico)
              this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
                console.warn('[Albarán IA] Error tracking modify_stock (no crítico):', err);
              });
            }
          } else if (this.ArrayAnalitica.list[i].type === 'product' && uid && uid !== "") {
            const product = productsMap[uid];
            if (product) {
              const stock_prod = parseFloat(product.stock) - _OldStock;
              const _total_prod = (_OldPrice * _Oldtax / 100) - _OldPrice;

              this.UpdateElement(product, this.ArrayAnalitica, _Oldtax, _OldPrice, _total_prod);
              
              // Añadir al batch en lugar de update individual
              const docRef = this.productsServices.afs.firestore.collection('products').doc(uid);
              batch.update(docRef, {
                'stock': stock_prod,
                'price_static': _OldPrice,
                'providers': product.providers,
              });
              
              // No bloquear el proceso con await para tracking (menos crítico)
              this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
                console.warn('[Albarán IA] Error tracking modify_stock (no crítico):', err);
              });
            }
          }
        }

        // ponemos los nuevos precios
        for (let i = 0; json_response.list.length > i; i++) {
          const uid = json_response.list[i].uid_product || json_response.list[i].uid_ingredient;
          const _stock = json_response.list[i].quantity;
          const _newPrice = json_response.list[i].price;
          const _tax = json_response.list[i].tax;

          if (json_response.list[i].type === 'ingredient' && uid && uid !== "") {
            const ingredient = ingredientsMap[uid];
            if (ingredient) {
              const stock_ingr = _stock + parseFloat(ingredient.stock);
              const _total_ingr = _newPrice + (_newPrice * _tax / 100);

              this.UpdateElement(ingredient, json_response, _tax, _newPrice, _total_ingr);
              
              // Añadir al batch en lugar de update individual
              const docRef = this.ingredientsServices.afs.firestore.collection('ingredients').doc(uid);
              batch.update(docRef, {
                'stock': stock_ingr,
                'price_static': _newPrice,
                'providers': ingredient.providers,
              });
              
              // No bloquear el proceso con await para tracking (menos crítico)
              this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
                console.warn('[Albarán IA] Error tracking modify_stock (no crítico):', err);
              });
            }
          } else if (json_response.list[i].type === 'product' && uid && uid !== "") {
            const product = productsMap[uid];
            if (product) {
              const stock_prod = _stock + parseFloat(product.stock);
              const _total_prod = _newPrice + (_newPrice * _tax / 100);

              this.UpdateElement(product, json_response, _tax, _newPrice, _total_prod);
              
              // Añadir al batch en lugar de update individual
              const docRef = this.productsServices.afs.firestore.collection('products').doc(uid);
              batch.update(docRef, {
                'stock': stock_prod,
                'price_static': _newPrice,
                'providers': product.providers,
              });
              
              // No bloquear el proceso con await para tracking (menos crítico)
              this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
                console.warn('[Albarán IA] Error tracking modify_stock (no crítico):', err);
              });
            }
          }
        }

        // OPTIMIZACIÓN: Commit de todas las actualizaciones en una sola operación
        await batch.commit();

      } catch (error) {
        console.error('Error in getValuesToUpdate (update state):', error);
      }
    } else { // NOT UPDATE STATE
      try {
        // OPTIMIZACIÓN: Recopilar todos los UIDs primero
        const ingredientUids: string[] = [];
        const productUids: string[] = [];
        const newElements = []; // Elementos que no existen y hay que crear

        for (let i = 0; json_response.list.length > i; i++) {
          const uid = json_response.list[i].uid_product || json_response.list[i].uid_ingredient;
          
          if (this.update_state === false) {
            this.CreateArrayAnalitics(json_response.list[i], uid, json_response.list[i].price);
          }

          if (uid && uid !== "") {
            if (json_response.list[i].type === 'ingredient') {
              ingredientUids.push(uid);
            } else if (json_response.list[i].type === 'product') {
              productUids.push(uid);
            }
          } else {
            // Elemento sin UID, hay que crearlo después
            newElements.push({ index: i, item: json_response.list[i] });
          }
        }

        // OPTIMIZACIÓN: Obtener todos los documentos en batch
        const ingredientsMap = await this.getBatchDocuments('ingredients', ingredientUids);
        const productsMap = await this.getBatchDocuments('products', productUids);

        // Crear batch para todas las actualizaciones
        const batch = this.ingredientsServices.afs.firestore.batch();

        // Procesar elementos existentes
        for (let i = 0; json_response.list.length > i; i++) {
          const uid = json_response.list[i].uid_product || json_response.list[i].uid_ingredient;
          const _stock = json_response.list[i].quantity;
          const _newPrice = json_response.list[i].price;
          const _tax = json_response.list[i].tax;

          if (json_response.list[i].type === 'ingredient' && uid && uid !== "") {
            const ingredient = ingredientsMap[uid];
            if (ingredient) {
              const stock_ingr = _stock + parseFloat(ingredient.stock);
              const _total_ingr = _newPrice + (_newPrice * _tax / 100);

              this.UpdateElement(ingredient, json_response, _tax, _newPrice, _total_ingr);
              
              // Añadir al batch
              const docRef = this.ingredientsServices.afs.firestore.collection('ingredients').doc(uid);
              batch.update(docRef, {
                'stock': stock_ingr,
                'price_static': _newPrice,
                'providers': ingredient.providers,
              });
              
              // No bloquear el proceso con await para tracking (menos crítico)
              this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
                console.warn('[Albarán IA] Error tracking modify_stock (no crítico):', err);
              });
            }
          } else if (json_response.list[i].type === 'product' && uid && uid !== "") {
            const product = productsMap[uid];
            if (product) {
              const stock_prod = _stock + parseFloat(product.stock);
              const _total_prod = _newPrice + (_newPrice * _tax / 100);

              this.UpdateElement(product, json_response, _tax, _newPrice, _total_prod);
              
              // Añadir al batch
              const docRef = this.productsServices.afs.firestore.collection('products').doc(uid);
              batch.update(docRef, {
                'stock': stock_prod,
                'price_static': _newPrice,
                'providers': product.providers,
              });
              
              // No bloquear el proceso con await para tracking (menos crítico)
              this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], uid).catch(err => {
                console.warn('[Albarán IA] Error tracking modify_stock (no crítico):', err);
              });
            }
          }
        }

        // OPTIMIZACIÓN: Commit de todas las actualizaciones en una sola operación
        await batch.commit();

        // Crear nuevos elementos (estos no se pueden hacer en batch porque necesitan IDs)
        for (let newEl of newElements) {
          const _provider = Array();
          _provider.push({
            uid: json_response.uid_provider,
            default: true,
            price_static: newEl.item.price,
            name_static: json_response.provider_static,
            pricetotal_static: newEl.item.total,
            tax_static: newEl.item.tax,
            updated_at: new Date(),
          });
          await this.CreateElementIfnotExist(newEl.item, _provider);
        }

      } catch (error) {
        console.error('Error in getValuesToUpdate (new state):', error);
      }
    }
    this.calculateTotals();
  }

  // NUEVO MÉTODO: Obtener múltiples documentos en una sola llamada
  async getBatchDocuments(collection: string, uids: string[]): Promise<{ [key: string]: any }> {
    if (uids.length === 0) {
      return {};
    }

    const firestore = this.ingredientsServices.afs.firestore;
    const docRefs = uids.map(uid => firestore.collection(collection).doc(uid));
    
    // Firestore getAll() puede manejar hasta 10 documentos por llamada
    // Si hay más, dividir en chunks
    const chunkSize = 10;
    const chunks = [];
    for (let i = 0; i < docRefs.length; i += chunkSize) {
      chunks.push(docRefs.slice(i, i + chunkSize));
    }

    const resultsMap: { [key: string]: any } = {};

    for (let chunk of chunks) {
      // Firebase v5 no tiene getAll(), usar Promise.all con get() individual
      const promises = chunk.map(docRef => docRef.get());
      const docs = await Promise.all(promises);
      docs.forEach((doc: firebase.firestore.DocumentSnapshot) => {
        if (doc.exists) {
          // Deep copy para evitar referencias compartidas entre objetos
          const data = JSON.parse(JSON.stringify(doc.data()));
          data.UID = doc.id;
          resultsMap[doc.id] = data;
        }
      });
    }

    return resultsMap;
  }

  async CreateElementIfnotExist(json_response, _provider) {
    // ✅ Normalizar nombre para búsqueda
    const normalizedName = this.normalizeText(json_response.name);
    
    // si hay nuevos productos o ingredintes
    if (json_response.type == "product") {
      // ✅ PASO 1: Buscar si ya existe un producto con el mismo nombre
      const existingProducts = await this.productsServices.afs.collection('products')
        .ref
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .get();
      
      let duplicate = null;
      existingProducts.forEach(doc => {
        const data = doc.data();
        if (this.normalizeText(data.name) === normalizedName) {
          duplicate = { id: doc.id, ...data };
        }
      });

      if (duplicate) {
        console.warn(`[IA] Producto duplicado detectado: "${json_response.name}" ya existe con UID: ${duplicate.id}`);
        json_response.uid_product = duplicate.id;
        json_response.name = duplicate.name;  // Usar el nombre existente
        return;  // ⚠️ NO CREAR, usar el existente
      }

      // ✅ PASO 2: Si no existe, crear nuevo producto
      await this.productsServices.afs.collection('products').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'allergens': [],
        'aiAttempts': 1,  // CAMBIO: marcar que fue creado por IA
        'created_at': new Date(),
        'description_ca': '',
        'description_de': '',
        'description_en': '',
        'description_es': '',
        'description_fr': '',
        'description_it': '',
        'ean': json_response.ean || '',  // CAMBIO: guardar EAN si existe
        'featured': false,
        'image': '',
        'measurement': json_response.measurement,
        'name': json_response.name,
        'name_ca': json_response.name,
        'name_de': json_response.name,
        'name_en': json_response.name,
        'name_fr': json_response.name,
        'name_it': json_response.name,
        'observations': `Creado automáticamente por IA desde albarán`,  // CAMBIO: añadir nota
        'pos_background_color': '',
        'pos_border_color': '',
        'pos_color_name': '',
        'pos_favourite': false,
        'price_static': json_response.price,
        'provider_static': json_response.provider_static || _provider[0].name_static,
        'providers': _provider,
        'pvp': 0,
        'pvp2': 0,
        'pvp3': 0,
        'pvp_combo_extra': 0,
        'pvp_supplement': 0,
        'pvp_takeaway': 0,
        'stock': json_response.quantity,
        'stock_alert': 0,
        'stock_max': 0,
        'sub_recipe': false,
        'tags': ['ai-created'],  // CAMBIO: tag para identificar
        'tags_static': 'ai-created',
        'tax': json_response.tax || this.globals.RESTAURANT_TAX,
        'tk_active': false,
        'tpv_active': true,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name + ' (IA)',
        'variations_favourite': []
      }).then(doc => {
        json_response.uid_product = doc.id;
        this.analyticsService.trackingExpArticles('create product', this.globals.tracking_exp['create_article'], doc.id);
      });
    }
    else {
      // ✅ PASO 1: Buscar si ya existe un ingrediente con el mismo nombre
      const existingIngredients = await this.ingredientsServices.afs.collection('ingredients')
        .ref
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .get();
      
      let duplicate = null;
      existingIngredients.forEach(doc => {
        const data = doc.data();
        if (this.normalizeText(data.name) === normalizedName) {
          duplicate = { id: doc.id, ...data };
        }
      });

      if (duplicate) {
        console.warn(`[IA] Ingrediente duplicado detectado: "${json_response.name}" ya existe con UID: ${duplicate.id}`);
        json_response.uid_ingredient = duplicate.id;
        json_response.name = duplicate.name;  // Usar el nombre existente
        return;  // ⚠️ NO CREAR, usar el existente
      }

      // ✅ PASO 2: Si no existe, crear nuevo ingrediente
      await this.ingredientsServices.afs.collection('ingredients').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'name': json_response.name,
        'measurement': json_response.measurement,
        'stock': json_response.quantity,
        'stock_alert': 0,
        'stock_max': 0,
        'sub_recipe': false,
        'tags': ['ai-created'],  // CAMBIO: tag para identificar
        'tags_static': 'ai-created',
        'price_static': json_response.price,
        'provider_static': json_response.provider_static || _provider[0].name_static,
        'providers': _provider,
        'created_at': new Date(),
        'updated_at': new Date(),
        'observations': `Creado automáticamente por IA desde albarán`,  // NUEVO
        'aiAttempts': 1  // NUEVO: marcar creación por IA
      }).then(doc => {
        json_response.uid_ingredient = doc.id;
        this.analyticsService.trackingExpStock('create_ingredient', this.globals.tracking_exp['create_ingredient'], doc.id);
      });
    }
  }

  // ✅ MÉTODO AUXILIAR: Normalizar texto (debe ser idéntico al de process-foto-ia)
  normalizeText(text: string): string {
    if (!text) return '';
    return text
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')  // Quitar acentos
      .replace(/\s+/g, ' ')  // Múltiples espacios → 1 espacio
      .trim();
  }

  // NOTA: updateNewValues ya no se usa - se reemplazó con batch operations en getValuesToUpdate

  // acabar el proceso y ver / volver lista albaran
  async finish_proceses() {
    this.show_alert = false;
    await this.insertAI(this.json_Response);

    this.navCtrl.setRoot(FinishProcessPage, {
      uid_element: this.delibery_note_uid,
      type: 'delibery_note',
    })
  }

  // insertamos el alabran a firestore 
  async insertAI(json_Response) {
    json_Response['uid_provider_order'] = ""
    // Asegúrate de que UID_RESTAURANT esté presente
    json_Response['UID_RESTAURANT'] = this.globals.restaurant_uid;
    // Marcar como completado (los albaranes IA se crean ya finalizados)
    json_Response['state'] = 'completed';
    // Convert the date to Firestore Timestamp
    if (json_Response.date) {
      json_Response.date = firebase.firestore.Timestamp.fromDate(new Date(json_Response.date));
    }

    // para cambiar uid_product a ingredient
    for (let i = 0; i < this.json_Response.list.length; i++) {
      if (this.json_Response.list[i].type === 'ingredient' && this.json_Response.list[i].uid_product) {
        // Assign uid_product to uid_ingredient if it's an ingredient
        this.json_Response.list[i].uid_ingredient = this.json_Response.list[i].uid_product;
        delete this.json_Response.list[i].uid_product; // Optionally delete uid_product if not needed
      }
    }

    await this.getValuesToUpdate(json_Response);
    await this.globals.delay(1000);
    await this.globals.afs.collection('delibery_note').add(json_Response).then(async doc => {
      //Get the UID Document
      this.delibery_note_uid = await doc.id;
      this.analyticsService.trackingExpStock('create_delivery_note', this.globals.tracking_exp['create_delivery_note'], this.delibery_note_uid).catch(err => {
        console.warn('[Albarán IA] Error tracking create_delivery_note (no crítico):', err);
      });
      await this.sendAnalitica();
    }).catch(function (error) {

    });
  }

  async sendAnalitica() {
    //Controlamos que en array tenga como minimo algun elemento
    if (this.elements_stock.length > 0) {
      this.globals.GAtrackView('Stock', 'Stock - Delibery note - Select quantity price - Create', this.globals.restaurant.email, 'Create/Update', 'Create  select quantity price delibery note', 'Stock', '');
      //Creamos el array para stock analytics
      var stock

      if (this.update_state) {
        stock = {
          "elements": this.elements_stock,
          "uid": this.globals.restaurant_uid,
          "date": new Date(),
          "type": "stock",
          "comment": `${this.translate.instant('general-editar-albaran')} / ${this.globals.user_name}`,
          "type_type": "ALBARAN",
          "delivery_uid": this.delibery_note_uid
        }
      } else {
        stock = {
          "elements": this.elements_stock,
          "uid": this.globals.restaurant_uid,
          "date": new Date(),
          "type": "stock",
          "comment": `${this.translate.instant('provider-order-view-crear-albaran')} / ${this.globals.user_name}`,
          "type_type": "ALBARAN",
          "delivery_uid": this.delibery_note_uid
        }
      }

      //Creamos el array para stock_purchases analytics
      var stock_purchases = {
        "uid": this.globals.restaurant_uid,
        "date": new Date(),
        "type": "stock_purchases",
        "delivery_uid": this.delibery_note_uid
      }
      
      //Enviamos a _data con manejo de errores mejorado
      try {
        const results = await Promise.all([
          this.analyticsService.sendStock(stock),
          this.analyticsService.sendStockPurchases(stock_purchases)
        ]);
        
        if (results.every(r => r === true)) {
          // Analytics enviado correctamente
        } else {
          console.warn(`[Albarán IA] Algunos analytics fallaron pero se guardaron en cola de reintentos`);
        }
      } catch (error) {
        console.error('[Albarán IA] Error crítico enviando analytics:', error);
        // Continuar aunque falle analytics - no bloquear al usuario
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-result-foto-ia/delibery-note-result-foto-ia.ts